import { createFileRoute } from '@tanstack/react-router';

import { LibraryPage } from '@/features/library';
import { workspaceSearchSchema } from '@/patterns';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/documents/')({
  validateSearch: workspaceSearchSchema.extend({ folder: zSearchText(), upload: zSearchText(), newFolder: zSearchText() }),
  component: function Documents() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <LibraryPage search={search} onSearchChange={(patch, o) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false })} />;
  },
});
